import React from 'react';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';
import Option from '../form/types/Option.ts';
import { cn } from '@/lib/utils.ts';

const ToggleButtons = ({
  options,
  className = '',
  onChange,
  selected,
  label,
  required = false,
  hint,
}: {
  options: Option[];
  className?: string;
  onChange: (id: string) => void;
  selected: string;
  label?: string;
  required?: boolean;
  hint?: string;
}) => {
  return (
    <div className="flex flex-col gap-1.5 overflow-hidden">
      {label && <InputLabel label={label} required={required} />}
      <div
        className={`flex w-fit gap-1 rounded-md bg-neutral-100 p-[3px] ${className} `}
      >
        {options.map((option) => (
          <button
            key={option.value}
            className={cn(
              'rounded-sm px-3 py-[7px] text-sm font-medium leading-[100%]',
              selected === option.value
                ? 'bg-basic-white text-basic-black'
                : 'bg-none text-neutral-500 hover:bg-neutral-200 hover:text-base-text',
            )}
            onClick={() => onChange(option.value)}
            type={'button'}
          >
            {option.label}
          </button>
        ))}
      </div>
      {hint && <InputHint hint={hint} />}
    </div>
  );
};

export default ToggleButtons;
